import { useGroups } from '@entities/common/groups';
import { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { Search, useFilter } from '@features/common';
import { Add, ArrowShortLeft } from '@shared/assets';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { IconButton, ListBody, PageHead, PageTitle, TextButton } from '@shared/ui';
import * as st from './styles.module.scss';
import { GroupItem } from './ui/group-item';

export const SelectGroup = (): JSX.Element => {
  const { search, onSearch } = useFilter();
  const {
    groups,
    setSelectedGroup,
    isSelectedAtAnyGroups,
    addSelectedToGroups,
    removeFromSelectedGroups,
    selectedGroups,
  } = useGroups();
  const [groupsToShow, setGroupsToShow] = useState(groups);
  const { id } = useParams();
  const { module, code } = useModuleByCodeParam();
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  const { state } = useLocation();

  const handleSubmit = () => {
    const idValue = isNaN(Number(id)) ? 'create' : id;
    navigate(`/events/events/${idValue}`, { state });
  };

  const handleSelectGroup = (group: any) => {
    if (isSelectedAtAnyGroups(group)) {
      removeFromSelectedGroups(group);
    } else {
      addSelectedToGroups(group);
    }
  };

  useEffect(() => {
    const selectedGroupIds = selectedGroups.map((group) => group.id);
    const groupsToShow = groups.filter((group) => !selectedGroupIds.includes(group.id));
    setGroupsToShow(groupsToShow);
  }, []);

  return (
    <>
      <PageTitle title="Выбрать группу " />

      <PageHead
        Left={
          <IconButton variant="dark" onClick={goBack}>
            <ArrowShortLeft />
          </IconButton>
        }
        Right={
          <>
            <Tooltip title="Поиск" disableInteractive>
              <Search search={search} onSearch={onSearch} />
            </Tooltip>
            <NavLink to={`#`}>
              <Tooltip title="Создать" disableInteractive>
                <div>
                  <IconButton variant="dark">
                    <Add />
                  </IconButton>
                </div>
              </Tooltip>
            </NavLink>
            <TextButton type="button" onClick={handleSubmit}>
              Готово
            </TextButton>
          </>
        }
      />

      <ListBody>
        <ul className={st.list}>
          {groupsToShow.map((group: any) => {
            const isGroupSelected = isSelectedAtAnyGroups(group);
            return (
              <li key={group.id}>
                <GroupItem isChecked={isGroupSelected} onCheck={() => handleSelectGroup(group)}>
                  {group.name}
                </GroupItem>
              </li>
            );
          })}
        </ul>
      </ListBody>
    </>
  );
};
